// AUTO-GENERATED by scripts/optimize-images/optimize.js — do not edit by hand.
// Run `npm start` in that directory after adding photos to assets/images/gallery.

export interface GalleryPhoto {
  /** Filename inside /assets/gallery/full and /assets/gallery/thumb. */
  file: string;
}

/**
 * One album, in no particular year. The photos come from several festivals and
 * the dates were dropped on purpose - see the gallery copy.
 */
export const galleryPhotos: GalleryPhoto[] = [
  { file: '20160917-133140.jpg' },
  { file: '20160917-133225.jpg' },
  { file: '20160917-135933.jpg' },
  { file: '20160917-152222.jpg' },
  { file: '20160917-154850.jpg' },
  { file: '20160917-154854.jpg' },
  { file: '20170916-150915.jpg' },
  { file: 'img-20170915-192752.jpg' },
  { file: 'img-20170916-062642.jpg' },
  { file: 'img-20170916-063501.jpg' },
  { file: 'img-20170916-133007.jpg' },
  { file: 'img-20170916-133518.jpg' },
  { file: 'img-20170916-133843.jpg' },
  { file: 'img-20170916-133848.jpg' },
  { file: 'img-20170916-133851-1.jpg' },
  { file: 'img-20170916-134038.jpg' },
  { file: 'img-20170916-134640.jpg' },
  { file: 'img-20170916-135617.jpg' },
  { file: 'img-20170916-135624.jpg' },
  { file: 'img-20170916-140308.jpg' },
  { file: 'img-20170916-140603.jpg' },
  { file: 'img-20170916-140630.jpg' },
  { file: 'img-20170916-140824.jpg' },
  { file: 'img-20170916-140853.jpg' },
  { file: 'img-20170916-141631.jpg' },
  { file: 'img-20170916-141658.jpg' },
  { file: 'img-20170916-144221.jpg' },
  { file: 'img-20170916-144819-01.jpg' },
  { file: 'img-20170916-144819-03.jpg' },
  { file: 'img-20170916-144819-04.jpg' },
  { file: 'img-20170916-144819-05.jpg' },
  { file: 'img-20170916-144819-06.jpg' },
  { file: 'img-20170916-144831-02.jpg' },
  { file: 'img-20170916-144834-01.jpg' },
  { file: 'img-20170916-144849.jpg' },
  { file: 'img-20170916-185438.jpg' },
  { file: 'paint-by-number-recovered.jpg' },
  { file: 'unnamed.jpg' },
];

export default galleryPhotos;
